<div class="docs-page">
  <nav class="breadcrumb">
    <a [routerLink]="docsHome">Documentation</a>
    <span class="breadcrumb__sep">›</span>
    <a [routerLink]="groupRoute(currentGroup)">{{ currentGroup.title }}</a>
    <span class="breadcrumb__sep">›</span>
    <span class="breadcrumb__current">{{ currentPage.title }}</span>
  </nav>
  <div class="docs">
    <nav class="docs__nav">
      @for (group of groups; track group.title) {
        <div class="docs__nav__group">
          <div class="docs__nav__group__title">
            {{ group.title }}
            @if (group.tag) {
              <span class="docs__nav__tag">{{ group.tag }}</span>
            }
          </div>
          @for (doc of group.pages; track doc.slug) {
            <a
              class="docs__nav__item"
              [routerLink]="docRoute(doc)"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              {{ doc.title }}
              @if (doc.tag) {
                <span class="docs__nav__tag">{{ doc.tag }}</span>
              }
            </a>
          }
        </div>
      }
    </nav>
    <div class="docs__content">
      <markdown class="docs-content" [src]="docSrc" (click)="handleContentClick($event)"></markdown>
    </div>
  </div>
</div>
